<app-header></app-header>

<div style="height: 100%;">
  <router-outlet></router-outlet>
</div>